export default {"src":"/_next/static/media/point-circle-gray.46b7a1eb.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};